import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode.react';
import { AuthContext } from '../components/AuthProvider';
import { showTemporaryMessage } from "../components/Message";
import AddScanTokens from '../components/AddScanTokens';
import { useTranslation } from 'react-i18next';
import { generate_qr_code } from '../tools';

import {
    get_number_of_unused_scan_tokens,
    get_unused_scan_tokens,
    mark_scan_code_as_printed
} from "../tools-network";

const Printer = () => {
    const {
        userId,
        userType,
        loginToken,
        handleInvalidToken
    } = React.useContext(AuthContext);

    const isAdminUser = userType === 'ADMIN';
    const printerUser = (userType === 'PRINTER' ? userId : null);

    const [numberOfUnusedScanTokens, setNumberOfUnusedScanTokens] = useState(null);
    const [guiEnabled, setGuiEnabled] = useState(true);
    const [currentToken, setCurrentToken] = useState("");
    const [currentQrCode, setCurrentQrCode] = useState(null);

    const { t } = useTranslation();

    useEffect(() => {
        get_number_of_unused_scan_codes();
    }, []);

    useEffect(() => {
        console.log("Current token: " + JSON.stringify(currentToken));
    }, [currentToken]);

    const scanTokensAdded = () => {
        get_number_of_unused_scan_codes();
    };

    const get_number_of_unused_scan_codes = async () => {
        try {
            const res = await get_number_of_unused_scan_tokens(loginToken);
            if (res.success) {
                setNumberOfUnusedScanTokens(res.tokens_unused);
            } else {
                showTemporaryMessage("Fetch bearer data FAILED: " + res.msg, '', 'danger');
                handleInvalidToken();
            }
        } catch (err) {
            showTemporaryMessage("Fetch bearer data FAILED: " + err, '', 'danger');
            handleInvalidToken();
        }
    }

    const getScanToken = async () => {
        let scan_token;
        try {
            const res = await get_unused_scan_tokens(loginToken, 1);
            console.log("getScanToken res: " + JSON.stringify(res));
            if (res.success) {
                if (res.data.length === 0) {
                    setCurrentToken(null);
                } else {
                    const obj = res.data[0];
                    const value = obj.token;
                    setCurrentToken(value);
                }
            } else {
                showTemporaryMessage("Fetch unused scan token FAILED: " + res.msg, 'danger');
                handleInvalidToken();
            }
        } catch (err) {
            showTemporaryMessage("Fetch unused scan token FAILED: " + err, 'danger');
            handleInvalidToken();
        }
    }

    const markAsPrinted = async () => {
        try {
            await mark_scan_code_as_printed(loginToken, currentToken, printerUser);
        } catch (err) {
            showTemporaryMessage("Marking QR code as printed FAILED: " + err, "", 'danger');
        }
        get_number_of_unused_scan_codes();
        getScanToken();
    }

    return (
        <div className="flex-grow min-w-full">
            {/* Heading */}
            <div className="super-admin w-full bg-light-blue shadow mb-10">
                <div className="max-w-screen-xl mx-auto py-4 px-4 text-center sm:text-start">
                    <h1 className="text-4xl font-extrabold text-black">Printer</h1>
                </div>
            </div>

            {/* Constrained Content */}
            <div className="max-w-screen-xl mx-auto px-8 md:px-0">
                <p className="text-base mb-6">{t("page_printer_instructions")}</p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {/* Create QR-code */}
                    <div className="h-full">
                        {isAdminUser && <AddScanTokens scanTokensAdded={scanTokensAdded} />}
                    </div>
                    {/* Available QR-codes */}
                    <div className="flex flex-col neumorp text-center justify-top items-center py-4">
                        <h2 className="font-bold text-xl">{t("available_qr_codes")}:</h2>
                        {numberOfUnusedScanTokens === null ? (
                            <svg className="animate-spin h-8 w-8 mt-2 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                            </svg>
                        ) : (
                            <span className="text-4xl font-lucida font-bold">{numberOfUnusedScanTokens}</span>
                        )}
                    </div>
                    {/* Print QR-code */}
                    <div className="flex flex-col neumorp text-center justify-top items-center py-4">
                        <h2 className="font-bold text-xl mb-1">{t("print_qr_code")}</h2>
                        <button
                            className="btn-main disabled:bg-gray-300"
                            disabled={!guiEnabled || numberOfUnusedScanTokens === null || numberOfUnusedScanTokens === 0}
                            onClick={getScanToken}
                        >
                            {t("get_qr_code")}
                        </button>
                        {currentToken && (
                            <div className="content-box mt-4 p-2 self-center">
                                <QRCode value={generate_qr_code(currentToken)} />
                                <a href={generate_qr_code(currentToken)}>QR CODE</a>
                            </div>
                        )}
                        {printerUser && (
                            <button
                                className="mt-4 bg-green-500 text-white px-4 py-2 rounded disabled:bg-gray-300"
                                disabled={!guiEnabled || !currentToken}
                                onClick={markAsPrinted}
                            >
                                {t("mark_as_printed")}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Printer;